import {  useState,useContext } from "react";
import PayRollIncidentContext from "../../../context/PayRollIncidentContext/PayRollIncidentContext";
import { payrollIncidentModal } from "../../../context/PayRollIncidentContext/Actions";
import Box from '@mui/material/Box';
import { IconButton, Menu, MenuItem } from "@material-ui/core";
import MoreVertIcon from '@material-ui/icons/MoreVert';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import PayrollProcessContext from "../../../context/PayrollProcess/PayrollProcessContext";
import { deleteIncidentPeriodicProcess } from "../../../context/PayrollProcess/Actions";


const MenuPayrollIncidents = ({idPayRoll,infoRow}:any) => {
    const { dispatch:payrollIncidentDispatch} = useContext(PayRollIncidentContext)
    const { dispatch } = useContext(PayrollProcessContext);
    const [anchorEl, setAnchorEl] = useState<any>(null);
    const open = Boolean(anchorEl);   

    const openMenu = (e: any): void => {
        setAnchorEl(e.currentTarget);
      };

   
      
    const modalOpen = (id:string,editView:string,modalEdit: boolean,) =>{
        setAnchorEl(null);        
        switch (editView) {
          case 'edit':
          return  payrollIncidentModal({_id:id,payRollIncident:infoRow,editView:'edit',modalPayRollIncendent:modalEdit},payrollIncidentDispatch)      
          
          case 'view':
            return payrollIncidentModal({_id:id,payRollIncident:infoRow,editView:'view',modalPayRollIncendent:modalEdit},payrollIncidentDispatch)                
          
        }         
     
      }

  

      const deleteModal =async (id:any ) =>{
        setAnchorEl(null);          
        deleteIncidentPeriodicProcess({ _id: id, showDeleteIncidentPeriodic: true }, dispatch);   
      }  
   
      const menuDelete = ()=>{
        return <MenuItem                  
                 onClick={() => deleteModal(idPayRoll)}
                 >
               <div className='containerIcon'>
                <div><span className="txtMenuPayRollIncident">Eliminar</span> </div>
               </div>
               <DeleteIcon  fontSize="small"  style={{ color: "#E57171" }}/>
           </MenuItem>        
         }  

  return (
    <>
        <Box mr={2} 
            className="menuListNewPrestacion">
          <IconButton onClick={openMenu}
             className="menuListOptionNewPrestacion"
           >
            <MoreVertIcon  className="moreOptionNewPrestacion"  />  
            </IconButton>
        </Box>
       <Menu
          className="MoreVerIcon"
          anchorEl={anchorEl}
          open={open}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
          onClose={() => setAnchorEl(null)}>
         
          <MenuItem 
               onClick={() => modalOpen(idPayRoll,'view', true)}
             >
            <div className='containerIcon'>
                <div>
                    <span className="txtMenuPayRollIncident">Ver</span>               
                </div>
              </div>
              <VisibilityIcon fontSize="small"  style={{ color: "#2186C6" }} />              
          </MenuItem>                  
          {
            menuDelete()             
          }
      </Menu>   
     
  </>
  )
}

export default MenuPayrollIncidents